import styled from "styled-components";

export const StyledLink = styled.a`
  display: flex;
  justify-content: space-between;
  font-size: 1rem !important;
  font-family: Arial !important;
  padding: 10px 16px;
  margin: 0px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: white !important;
  background-color: #1b1c1d !important;
  transition: all 0.1s ease-in-out;
  width: 100%;

  &:hover {
    cursor: pointer !important;
    background-color: rgba(255, 255, 255, 0.08) !important;
  }
`;

export const StyledLinkMenu = styled.a`
  cursor: default !important;
  background-color: #1b1c1d !important;
  padding-bottom: 20px;
  height: initial !important;
  max-height: ${(props) => (props.active ? "1000px" : "42px")} !important;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    font-size: 1rem !important;
    font-family: Arial !important;
    padding: 10px 16px;
    margin: 0px 0px 5px 0px !important;

    color: white !important;
    background-color: #1b1c1d !important;
    transition: all 0.08s ease-in-out;
    width: 100%;

    &:hover {
      cursor: pointer !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
    }
  }
`;

export const StyledLinkSubmenu = styled(StyledLink)`
  display: block;
  font-size: 0.85714286em !important;
  font-family: inherit !important;
  color: rgba(255, 255, 255, 0.5) !important;
  padding: 2px 16px 2px 20px;
  border: none;

  &:first-of-type {
    margin-top: 15px;
  }

  &:hover {
    display: block;
    font-size: 0.85714286em !important;
    font-family: inherit !important;
    color: rgba(255, 255, 255) !important;
  }
`;

export const InputContainer = styled.div`
  padding-inline: 12px;
  padding-bottom: 4px;
`